export const noteAddIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M20 8v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8l6 6zm-4 6h-3v-3h-2v3H8v2h3v3h2v-3h3v-2zm2.5-5L13 3.5V9h5.5z"/></svg>`,
  name: 'note-add',
};
